import { DroneEntity } from "@src/core/features";
import { MissionStep, RouteWaypointEntity } from '@src/features/order/pages/upsert-mission-page/entities';

export enum TerrainMode {
    RELATIVE = 'RELATIVE',
    AMSL = 'AMSL',
    AGL = 'AGL',
}

export interface IUpsertMissionInitialState {
    terrainMode: TerrainMode;
    editableRoute: boolean;
    routeModified: boolean;
    activeStep: MissionStep;
    expandedStep: MissionStep;
    wizardOrderId: string | null;
    waypoints: RouteWaypointEntity[];
    hoveredDrone: DroneEntity | null;
    selectedDrone: DroneEntity | null;
}